import { css } from '@emotion/css';

export const notificationTrayContainer = css`
  width: 48.3rem;
  height: 73.6rem;
`;

export const notificationTrayContainerMobile = css`
  /* dvh (not vh) so this tracks the actual visible viewport on iOS Safari instead of
     the layout viewport behind its toolbar, staying a fixed 100px from the top. */
  height: calc(100dvh - 50px);
`;
